
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { VanityAPI } from '../services/api';
import { Issue } from '../types';
import SEOPage from '../components/SEOPage';
import seoGlobals from '../seo_globals.json';

const Archive: React.FC = () => {
  const [archive, setArchive] = useState<Issue[]>([]);
  const years = [2025, 2024, 2023];

  useEffect(() => {
    VanityAPI.getArchive().then(setArchive);
  }, []);

  return (
    <div className="pt-40 pb-48 fade-in bg-vanity-white">
      <SEOPage
        title={`Archiv | VANITY`}
        description={seoGlobals.seo.defaultDescription}
      />
      <div className="max-w-[1440px] mx-auto px-8 md:px-12">
        <header className="mb-40 text-center max-w-4xl mx-auto space-y-10">
          <span className="font-sans text-[12px] uppercase tracking-[0.8em] text-vanity-pink font-extrabold">The Print Library</span>
          <h1 className="font-serif text-6xl md:text-9xl text-vanity-black leading-tight font-bold">Legacy of <br /> Excellence.</h1>
          <div className="h-px w-32 bg-vanity-pink mx-auto opacity-40"></div>
        </header>

        <div className="space-y-60">
          {years.map(year => {
            const issuesInYear = archive.filter(i => i.year === year);
            if (issuesInYear.length === 0) return null;

            return (
              <div key={year} className="relative">
                <div className="flex items-center mb-24 gap-12">
                  <h2 className="font-serif text-7xl md:text-[10rem] text-vanity-charcoal/10 select-none leading-none pointer-events-none font-bold">{year}</h2>
                  <div className="flex-1 h-px bg-vanity-charcoal/20"></div>
                  <span className="font-sans text-[11px] uppercase tracking-[0.4em] text-vanity-black font-extrabold">Collection</span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-24 lg:gap-32">
                  {issuesInYear.map((issue, idx) => (
                    <Link key={issue.id} to={issue.slug ? `/archive/${issue.slug}` : `/archive/${issue.id}`} className="group cursor-pointer block">
                      <div className="relative overflow-hidden mb-12 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.15)] bg-vanity-charcoal/5 aspect-[3/4] transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:shadow-[0_50px_100px_-20px_rgba(214,0,109,0.15)] group-hover:-translate-y-2">
                        <img
                          src={issue.coverUrl}
                          alt={`${issue.season} Edition`}
                          className="w-full h-full object-cover transition-all duration-[1.8s] ease-[cubic-bezier(0.16,1,0.3,1)] scale-100 group-hover:scale-105"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 bg-vanity-black/15 transition-opacity duration-1000 group-hover:opacity-0"></div>
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                          <div className="border border-white/50 bg-white/10 backdrop-blur-md px-6 py-3 text-white font-sans text-[10px] uppercase tracking-[0.3em] font-bold">View Anthology</div>
                        </div>
                      </div>
                      <div className="space-y-4 text-center md:text-left">
                        <h3 className="font-serif text-4xl text-vanity-black group-hover:text-vanity-pink transition-colors duration-500 font-bold">
                          {issue.title}
                        </h3>
                        <p className="font-sans text-[11px] uppercase tracking-[0.4em] text-vanity-charcoal font-extrabold opacity-70">
                          {issue.periodText} &middot; № {issue.issueDate}
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Archive;
